<template>
  <BModal
    id="modal-proove"
    no-close-on-esc
    hide-footer
    hide-header
    centered
  >
    <BRow class="my-2">
      <BCol
        v-if="prooveItem.type !== ''"
        cols="12"
        class="mb-2 text-center"
      >
        <span class="text-black text-[24px]">
          <strong>
            Lampiran Bukti Claim
          </strong>
        </span>
      </BCol>

      <BCol
        cols="12"
        class="mb-2"
      >
        <div class="form-group row align-items-center">
          <label class="col-sm-2 col-form-label">Resi</label>
          <div class="col-sm-10">
            <span class="text-black"> : {{ prooveItem.cnote }} </span>
          </div>
        </div>
        <div
          v-if="
            prooveItem.type !== 'tidak_diterima' &&
              prooveItem.type !== 'rts_tidak_diterima'
          "
          class="form-group row align-items-center"
        >
          <label class="col-sm-2 col-form-label">Video</label>
          <div class="col-sm-10 d-flex align-items-center">
            <span
              :class="
                prooveItem.video !== '-' && prooveItem.video !== ''
                  ? 'text-info cursor-pointer'
                  : 'text-info'
              "
              @click="
                prooveItem.video !== '-' && prooveItem.video !== ''
                  ? openPathVideo(prooveItem.video)
                  : null
              "
            >
              <span
                v-if="prooveItem.video !== '-' && prooveItem.video !== ''"
              ><span class="text-black">:</span>
                {{ `${prooveItem.video.substring(0, 35)}...` }}</span>
              <span
                v-else
                class="text-black"
              >: -</span>
            </span>
            <BImg
              v-if="prooveItem.video !== '-' && prooveItem.video !== ''"
              class="ml-1 cursor-pointer"
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/copy.svg"
              @click="copyPathVideo(prooveItem.video)"
            />
          </div>
        </div>
        <div class="form-group row align-items-start">
          <label class="col-sm-2 col-form-label">Foto</label>
          <div class="col-sm-10">
            <div
              v-if="prooveItem.images.length > 0"
              class="d-flex flex-wrap"
            >
              <div class="mr-50">
                :
              </div>
              <div
                v-for="(file, index) in prooveItem.images"
                :key="index"
                class="wrapper-preview-file mr-2 mb-2"
              >
                <b-img
                  :src="file.path"
                  class="img-preview cursor-pointer"
                  width="56"
                  style="border-radius: 12px; height: 56px;"
                  @click="openPreviewProof(file.path)"
                />
                <div>
                  <span> ...{{ file.path.slice(-9) }} </span>
                </div>
              </div>
            </div>

            <div v-else>
              <span class="mr-50">
                :
              </span>
              <span class="text-info">
                -
              </span>
            </div>
          </div>
        </div>
      </BCol>

      <BCol cols="12">
        <BButton
          variant="primary"
          block
          style="border-radius: 8px;"
          @click="$bvModal.hide('modal-proove')"
        >
          Tutup
        </BButton>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
import ToastificationContentVue from '@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    prooveItem: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    openPreviewProof(data) {
      window.open(data, '_blank')
    },
    copyPathVideo(data) {
      navigator.clipboard.writeText(data)
      this.$toast_copy({ title: `${data} berhasil disalin` })
    },
  },

}
</script>
